import { render } from "./MatrixMaterialGroup.vue?vue&type=template&id=31cf8484&scoped=true"
import script from "./MatrixMaterialGroup.vue?vue&type=script&lang=js"
export * from "./MatrixMaterialGroup.vue?vue&type=script&lang=js"

import "./MatrixMaterialGroup.vue?vue&type=style&index=0&id=31cf8484&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31cf8484"]])

export default __exports__